const ACTIONS = {
    CONFIRM_BRAND: 'CONFIRM_BRAND',
    DISMISS_ALERT_BOX: 'DISMISS_ALERT_BOX',
    REDIRECT_WITH_BRAND_SWITCH_PARAM: 'REDIRECT_WITH_BRAND_SWITCH_PARAM',
    CONFIRM_BRAND_SERVICE_ERROR: 'CONFIRM_BRAND_SERVICE_ERROR',

};

const ACTION_CREATORS = {
    confirmBrand(primarySite) {
        return {
            type: ACTIONS.CONFIRM_BRAND,
            payload: {
                primarySite
            }
        };
    },
    dismissAlertBox() {
        return {
            type: ACTIONS.DISMISS_ALERT_BOX
        };
    },

    redirectWithBrandSwitchParam(primarySite, currency, bankingCountry) {
        return {
            type: ACTIONS.REDIRECT_WITH_BRAND_SWITCH_PARAM,
            payload: {
                primarySite,
                currency,
                bankingCountry
            }
        };
    },

    brandServiceError(errorKey) {
        return {
            type: ACTIONS.CONFIRM_BRAND_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
